var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var SvgAscending = function (props) { return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 10 10", width: "1em", height: "1em" }, props, { children: _jsx("path", { fill: "currentColor", d: "M7.727 7.546A.3.3 0 0 1 7.47 8H2.53a.3.3 0 0 1-.257-.454L4.57 3.715a.5.5 0 0 1 .858 0z" }) }))); };
export default SvgAscending;
